import Request from '@hotmart-org-ca/request'

import Settings from 'common/helpers/settings/.'

const options = {
  headers: {
    application: 'Webinar'
  }
}

Request.register(Settings.api.oauth, {
  get: {
    'auth.token.check': '/rest/v1/user/me',
    'auth.check_token': '/oauth/check_token?token=:token',
    'auth.logout': '/logout'
  }
}, options)
Request.register(Settings.api.marketplace, {
  get: {
    'auth.user_profile': '/userprofile/rest/v1/user/profile'
  }
}, options)
